import { t } from '@hefe/i18n';
import { formatDateTime } from '@hefe/utils';
import { CrudResource } from '../models/crud.types';

export interface UserEmailAddress {
  id: number;
  user_id: number;
  email: string;
  receive_notifications: boolean;
  label?: string;
  created_at: string;
  updated_at: string;
}

export const UserEmailAddressCrud: CrudResource<UserEmailAddress> = {
  endpoint: '/users/:userId/email-addresses',
  rowKey: 'id',
  table: {
    name: 'user-email-addresses',
    columns: [
      {
        key: 'email',
        title: t('email'),
        dataIndex: 'email',
        default: true,
        sortType: 'string',
        showFilter: true,
      },
      {
        key: 'label',
        title: t('description'),
        dataIndex: 'label',
        default: true,
        sortType: 'string',
        showFilter: true,
      },
      {
        key: 'receive_notifications',
        title: t('users.email_addresses.form.fields.use_for_notifications'),
        dataIndex: 'receive_notifications',
        default: true,
        sortType: 'string',
        showFilter: true,
        render: (value: unknown) => (Boolean(value) ? t('yes') : t('no')),
      },
      {
        key: 'created_at',
        title: t('created_at'),
        dataIndex: 'created_at',
        default: true,
        showDateFilter: true,
        sortType: 'date',
        render: (value: unknown) =>
          typeof value === 'string' && value ? formatDateTime(value) : '',
      },
    ],
  },
  form: {
    createTitle: t('users.email_addresses.add'),
    editTitle: t('users.email_addresses.edit'),
    fields: [
      {
        name: 'email',
        label: t('users.email_addresses.form.fields.email'),
        type: 'email',
        placeholder: t('users.email_addresses.form.fields.email'),
        rules: [
          {
            required: true,
            type: 'email',
            message: t('form_errors.email'),
          },
        ],
      },
      {
        name: 'label',
        label: t('users.email_addresses.form.fields.description'),
        type: 'text',
        placeholder: t('users.email_addresses.form.fields.description'),
        rules: [],
      },
      {
        name: 'receive_notifications',
        label: t('users.email_addresses.form.fields.use_for_notifications'),
        /*checkboxText: t(
          'users.email_addresses.form.fields.use_for_notifications'
        ),*/
        type: 'checkbox',
        initalValue: false,
        rules: [],
      },
    ],
  },
};
